import React from 'react';
import {
  Card,
  Fade,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const COLUMN_WIDTHS = [140, 100, 90, 90, 90, 100];

export default function MonthListSkeleton() {
  return (
    <Fade in timeout={300}>
      <Card elevation={0} sx={{ borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {COLUMN_WIDTHS.map((w, i) => (
                  <TableCell key={i}><Skeleton variant="text" width={w} animation="wave" /></TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[1, 2, 3, 4, 5].map((row) => (
                <TableRow key={row}>
                  {COLUMN_WIDTHS.map((w, i) => (
                    <TableCell key={i}><Skeleton variant="text" width={w} animation="wave" /></TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Fade>
  );
}
